export const RendererViewModeTypes = Object.freeze({
  viewMain: "viewMain",
  view360: "view360",
  viewGas: "viewGas",
});
